import {createErrorPageRoute} from 'state/location/routing/errorPageRouting';
import {PageRoute} from 'state/location/routing/pageRouting';


export const pageErrorEntityNotFound: PageRoute = createErrorPageRoute('entity-not-found')

